import { render, staticRenderFns } from "./ControlloRichiestaEmissione.vue?vue&type=template&id=2a3be71a&"
import script from "./ControlloRichiestaEmissione.vue?vue&type=script&lang=js&"
export * from "./ControlloRichiestaEmissione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QStepper,QStep});
